import customProductAvailabilityReducer from "@store/Store/Data/CustomProductAvailability/CustomProductAvailabilityReducer";
import explodedViewReducer from "@store/Store/Data/ExplodedView/ExplodedViewReducer";
import promotionMessagesReducer from "@store/Store/Data/Promotions/PromotionMessagesReducer";
import rmaReasonsReducer from "@store/Store/Data/RmaReasons/RmaReasonsReducer";
import rmaRequestReducer from "@store/Store/Data/RmaRequest/RmaRequestReducer";
import { combineReducers } from "redux";

const dataReducers = {
    rmaRequest: rmaRequestReducer,
    rmaReasons: rmaReasonsReducer,
    explodedView: explodedViewReducer,
    customProductAvailability: customProductAvailabilityReducer,
    promotionMessages: promotionMessagesReducer,
};

export type DataReducers = typeof dataReducers;

const dataReducer = combineReducers(dataReducers);
export default dataReducer;
